module.exports = __webpack_public_path__ + "static/media/quakeIcon-green.cffcd26c.svg";